module.exports = __webpack_public_path__ + "static/IMG-20201206-WA0007-89bd63791946290a9c1d206f3be8d249.jpg";